import { useSelector } from "react-redux";
import { Box, Typography } from "@mui/material";
import { useHistory } from "react-router-dom";
import {
  selectExistingOrdersWithoutCancelled,
  selectTestKitsGLIsCurrentlyOffering
} from "store/reducers/order/OrderInformationSlice";
import { trackDashboardCtaClicked } from "analytics";
import { COLORS } from "components/v3/Theme/colors";
import { pushDescriptionIntoKitObject } from "utils/v3/testKitUtils";
import { Kit } from "types/kit";
import { PATHS } from "constants/pathConstants";
import DashboardCtaCard from "../DashboardCtaCard";

const DashboardResults = () => {
  const history = useHistory();
  const orders = useSelector(selectExistingOrdersWithoutCancelled);
  const kitsGLCurrentOffers = pushDescriptionIntoKitObject(
    useSelector(selectTestKitsGLIsCurrentlyOffering)
  );
  const ordersWithDocs = orders.filter((order: Kit) => {
    return order.documentIds?.length > 0;
  });

  const hasOrdersWithDocs = ordersWithDocs?.length > 0;

  if (!hasOrdersWithDocs) {
    return null;
  }

  return (
    <Box
      sx={{
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        gap: 4,
        padding: {
          xs: "32px 24px",
          md: "64px 32px 32px 32px"
        }
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          textAlign: "center"
        }}
      >
        <Typography sx={{ typography: { xs: "h4", md: "h3" } }}>
          Your Results
        </Typography>
        <Typography variant="body">
          Genomic insights, research, and disease-related resources.
        </Typography>
      </Box>
      <Box
        component="ul"
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          gap: 2,
          margin: { md: "auto" },
          padding: 0
        }}
      >
        {ordersWithDocs.map((currentOrder: Kit) => {
          const testOffer = kitsGLCurrentOffers?.find(
            (offer) => offer.glTestType === currentOrder?.glTestType
          );
          const testResultsUrl = `${PATHS.TEST_RESULTS_PAGE}/${currentOrder.glOrderId}`;

          return (
            <DashboardCtaCard
              header={testOffer.name}
              id={testOffer.glTestType}
              link={{
                onClick: () => {
                  trackDashboardCtaClicked({
                    workflow: "results_review",
                    ctaLocation: "dashboard_card",
                    ctaId: "test_result"
                  });
                  history.push(testResultsUrl);
                },
                overrideClick: true,
                text: "View your results",
                url: testResultsUrl
              }}
              subheader={testOffer.description}
              sx={{
                backgroundColor: COLORS.WHITE,
                paddingTop: "30px"
              }}
            />
          );
        })}
      </Box>
    </Box>
  );
};

export default DashboardResults;
